import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import RadioButton from '../radio-button/RadioButton';
import * as styles from './YesOrNotButtons.style';
export const YesOrNotButtons = _ref => {
  let {
    name,
    value,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.base
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: styles.option
  }, /*#__PURE__*/React.createElement(RadioButton, _extends({}, rest, {
    name: name,
    id: `${name}-yes-option`,
    text: "S\xEC",
    value: "true",
    checked: Boolean(value === 'true')
  }))), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: styles.option
  }, /*#__PURE__*/React.createElement(RadioButton, _extends({}, rest, {
    name: name,
    id: `${name}-no-option`,
    text: "No",
    value: "false",
    checked: Boolean(value === 'false')
  }))));
};
export default YesOrNotButtons;
var _StyledDiv = _styled("div").withConfig({
  displayName: "YesOrNotButtons___StyledDiv",
  componentId: "sc-1l61sg7-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "YesOrNotButtons___StyledDiv2",
  componentId: "sc-1l61sg7-1"
})(["", ""], p => p.$_css2);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "YesOrNotButtons___StyledDiv3",
  componentId: "sc-1l61sg7-2"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=YesOrNotButtons.js.map